<template>
    <div class="help-view">
        <div  class="help-banner">
			<p style="font-size: 36px;color: #FFFFFF;margin: 0px;margin-left: 885px;padding-top: 57px;">帮助文档</p>
			<div style="border: 1px solid rgba(142,155,169,0.5);width: 880px;height: 56px;border-radius: 6px;margin-left: 520px;background-color: #FFFFFF;margin-top: 30px;">
			<img style="margin-left: 27px;margin-top: 20px; transform: translateY(3px);"  src="../assets/help/serach.png"/>
			<input v-model="keyword" @keyup.enter="helpList"  style="border: 1px solid white; width: 70%;height: 40px;margin-left: 12px;" placeholder="输入问题关键词，如:超管转让、解散项目部"/>
			</div>
		</div>
		
		<div style="text-align: center;width: 100%;height: 400px;" v-if="list.length==0">
			<img src="../assets/help/no_data.png" style="width: 200px;margin-top: 150px;"/>
		</div>
		
		<div style="margin-top: 20px;"></div>
		<div style="margin-left: 360px;display: flex;">
			<div>
				<div  v-for="item in list" :key="item.id" style="border-bottom: 1px solid #ddd; width: 240px;">
					<div class="help_name cursor"  :class="{ help_check: activeId == item.id,help_check2: activeId == item.id&&cactiveId==0 }"  @click="help_show(item);activeId = item.id;cactiveId=0;">
						<span style="display: block;margin-top: 22px;margin-left: 22px;float: left;">{{item.name}}</span>
						<img :src="activeId == item.id&&jtlan_check? jtlan : jthui"   style="width: 14px;height: 8px;float: right; margin-top: 26px;margin-right: 22px;"/>
					</div>
					<div  v-for="item2 in item.article_list.slice(0, 3)" :key="item2.id">
						<div style="height: 56px;" v-if="item2.type==activeId&&jtlan_check" class="cursor help_ch" :class="{ help_ch_check: cactiveId == item2.id }"  @click="help_details(item2)">
							<div v-if="cactiveId == item2.id" style="width: 6px;height: 56px;background: #007BD3;border-radius: 5px 0px 0px 5px;float: left;"></div>
							<span style="margin-left: 28px;padding-top: 19px;color: #555555;    display: block;" >{{item2.title}}</span>
						</div>
					</div>	
				</div>
			</div>
			<div style="margin-left: 52px;" v-if="help_list&&activeId>0&&list.length!=0">
				<p>
					<span class="cursor" style="font-weight: bold;font-size: 16px;color: #007BD3;" @click="help_url">帮助</span>
					<span   style="color: #555555;"> > {{get_help_name}}</span>
				</p>
				<p style="font-weight: 400;font-size: 28px;color: #333333">{{get_help_name}}</p>
				<p style="width: 900px;height: 1px;background: #F1F1F1;"></p>
				<div style="width: 800px;color: #007BD3;font-weight: 400;font-size: 16px;">
					<div class="cursor" style="width: 350px;float: left;line-height: 42px;" v-for="item in article_list" :key="item.id" @click="help_details(item)">· {{item.title}}</div>
				</div>
			</div>
			
			<div style="margin-left: 52px;" v-if="!help_list&&cactiveId>0&&list.length!=0">
				<p>
					<span style="font-weight: bold;font-size: 16px;color: #007BD3;"> <span class="cursor" @click="help_url">帮助 </span>> <span class="cursor" @click="cactiveId=0;help_list=true">{{get_help_name}}</span></span>
					<span style="color: #555555;"> > {{get_name}}</span>
				</p>
				<p style="font-weight: 400;font-size: 28px;color: #333333">{{get_name}}</p>
				<p style=":xxxxxxfont-size: 14px;color: ##666666">更新时间:{{updatetime}}</p>
				<p style="width: 900px;height: 1px;background: #F1F1F1;"></p>
				<div v-html="content" style="min-height:400px;">
				</div>
				<div style="width: 904px;height: 1px;background: #EEEEEE;"></div>
				<div style="height: 70px;">
					<div class="cursor" style="float: left;margin-top: 20px;" v-if="up_info.id>0">
						<span>上一篇：</span>
						<span style="font-size: 16px;color: #027BD3;" @click="help_details(up_info)">{{up_info.title}}</span>
					</div>
					<div  class="cursor" style="float: right;margin-top: 20px;" v-if="below_info.id>0">
						<span>下一篇：</span>
						<span  style="font-size: 16px;color: #027BD3;" @click="help_details(below_info)">{{below_info.title}}</span>
					</div>
				</div>
			</div>
		</div>
		<div style="margin-top: 25px;;"></div>
    </div>
</template>
<script>
export default {
    name: 'HelpView',
    data() {
        return {
			jtlan_check:false,
			below_info:{},
			up_info:{},
			get_help_name:"",
			article_list:[],
			get_name:"",
			updatetime:"",
			content:"",
			activeId:0,
			cactiveId:0,
			keyword:"",
			jtlan: require('@/assets/help/jtlan-icon.png'),
			jthui: require('@/assets/help/jthui-icon.png'),
            logo: require('@/assets/help/banner5.png'),
			help_list:true,
			list:[
			]
        }
    },
	created() {
		const activeId = this.$route.query.activeId;
		const cactiveId = this.$route.query.cactiveId;
		const keyword = this.$route.query.keyword;
		this.activeId=activeId
		this.cactiveId=cactiveId;
		this.keyword=keyword;
	},
    async mounted() {
		this.helpList();
    },
    methods: {
		async helpList() {
			if(this.keyword){
				this.activeId=0;
				this.cactiveId=0;
			}
			const response = await fetch(this.$apiBaseUrl+"/api/website/help_list",{  
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: 'keyword=' + this.keyword
			});
			const data = await response.json();
			this.list=data.data;
			if(this.activeId){
				const matchedItem = this.list.find(item => item.id == this.activeId);
				console.log(matchedItem)
				if(matchedItem){
					this.help_show(matchedItem)
					if(this.cactiveId){
						console.log(matchedItem)
						const matchedItem2 = matchedItem.article_list.find(item2 => item2.id == this.cactiveId);
						if(matchedItem2){
							this.help_details(matchedItem2)
						}
					}

				}
			}
			// alert(this.activeId)
			// alert(this.cactiveId)
		},
		async help_details(item){
			this.cactiveId=item.id;
			this.help_list=false
			const response = await fetch(this.$apiBaseUrl+"/api/website/help_info",{
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: 'id=' + this.cactiveId+'&keyword=' + this.keyword
			});
			const data = await response.json();
			console.log(data)
			// this.list=data.data;
			this.get_name=data.data.info.title;
			this.updatetime=data.data.info.updatetime;
			this.content=data.data.info.content;
			this.below_info=data.data.below_info;
			this.up_info=data.data.up_info;
		},
		help_show(item){
			if(this.jtlan_check){
				this.jtlan_check=false
			}else{
				this.jtlan_check=true
			}
			if(item.id!=this.activeId){
				this.jtlan_check=true
			}
			this.get_help_name=item.name
			this.help_list=true;
			this.article_list=item.article_list
		},
		search(){
			this.$router.push("/helpdo?keyword="+this.keyword);	
		},
		help_url(){
			this.$router.push("/help");	
		}
    }
}
</script>
<style lang="scss" scoped>
.help-view {
	min-height:800px;
	.cursor{
		cursor:pointer
	}
	.help_ch{
		
	}
	.help_ch_check{
		background: #EBF7FF;
		border-radius: 10px;
		color: #007BD3;
	}
	.help_name{
		font-weight: bold;
		color: #333333;
		height: 56px;
	}
	.help-banner{
		height: 208px;
		background-image: url('../assets/help/banner5.png');
		
	}
	input:focus {
      outline: none;
      border: none;
	}
	.help_check{
		font-weight: bold;
		color: #007BD3;
	}
	
	.help_check2{
		background: #EBF7FF;
		border-radius: 10px;
	}
}
</style>